module.exports = __webpack_public_path__ + "static/media/visa-icon-blue.c29b79f9.PNG";